import { render } from "./ProLaboreEdit.vue?vue&type=template&id=4d8b081a&scoped=true"
import script from "./ProLaboreEdit.vue?vue&type=script&lang=js"
export * from "./ProLaboreEdit.vue?vue&type=script&lang=js"

import "./ProLaboreEdit.vue?vue&type=style&index=0&id=4d8b081a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8b081a"]])

export default __exports__